import Panel from '@/components/ui/Panel';
import MyCart from './MyCart';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { closeCartPanel } from '@/redux/slices/cartSlice';
import Button from '../Buttons/Button';
import classnames from 'classnames';
import Link from '../Link';
import { useCart } from './hooks/useCart';
import { ScreenSizeQueries } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

const CartPanel = () => {
  const dispatch = useDispatch();
  const cartState = useSelector((state: RootState) => state.cart);
  const { subTotal, checkout } = useCart();
  const sm = useMediaQuery(ScreenSizeQueries.sm);

  const panelContentStyles = classnames({ 'w-[628px]': sm }, { 'w-full': !sm });

  const handleOpenChange = () => {
    dispatch(closeCartPanel());
  };

  return (
    <Panel
      isOpen={cartState.isOpen}
      onOpenChange={handleOpenChange}
      size="medium"
      dataComponent="CartPanel"
    >
      <Panel.Content side="right" hasHorizontalPadding={false} className={panelContentStyles}>
        <Panel.Body>
          <MyCart context="panel" />
        </Panel.Body>
        <Panel.Footer className="border-t border-solid border-silver !px-16 !py-8">
          <div className="flex items-center justify-between pb-6">
            <span className="text-1">Subtotal</span>
            <span className="heading-5">${subTotal}</span>
          </div>
          <div className="py-4">
            <Button {...checkout.buttonProps} size="large" className="w-full" />
          </div>
          <div className="flex justify-center">
            <Link
              href={'/cart'}
              text="View cart"
              variant="text-link-2"
              className="flex self-end"
              onClick={() => dispatch(closeCartPanel())}
            />
          </div>
        </Panel.Footer>
      </Panel.Content>
    </Panel>
  );
};

export default CartPanel;
